// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.progress-bar[data-v-6f2a995d] {\r\n  width: 35%;\r\n  min-width: 100px;\n}\r\n", ""]);
// Exports
module.exports = exports;
